<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-calendar"
          :title="$route.params.id ? $t('Edit Event') : $t('New Event')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
          <v-select
                v-model="formValues.event_category_id"
                :items="eventCategories"
                :label="$t('Event Kategorie')"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('event_category_id')"
              ></v-select>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.name"
                  label="Name"
                  v-validate="'required'"
                  required
                  data-vv-name="name"
                  :error-messages="errors.collect('name')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.name_it"
                  label="Name IT"
                  v-validate="'required'"
                  required
                  data-vv-name="name_it"
                  :error-messages="errors.collect('name_it')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>            
                <v-text-field
                  v-model="formValues.location"
                  label="Ort"
                  v-validate="'required'"
                  required
                  data-vv-name="location"
                  :error-messages="errors.collect('location')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.location_it"
                  label="Ort IT"
                  v-validate="'required'"
                  required
                  data-vv-name="location_it"
                  :error-messages="errors.collect('location_it')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  v-model="formValues.description"
                  label="Beschreibung"
                  v-validate="'required'"
                  required
                  data-vv-name="description"
                  :error-messages="errors.collect('description')"
                ></v-textarea>
              </v-col>
              <v-col>
                <v-textarea
                  v-model="formValues.description_it"
                  label="Beschreibung IT"
                  v-validate="'required'"
                  required
                  data-vv-name="location_it"
                  :error-messages="errors.collect('location_it')"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <base-date-picker
                        v-model="formValues.from"
                        label="Datum Start"
                        :errors="errors.collect('from')"
                      ></base-date-picker>
              </v-col>
              <v-col>
                <v-col>
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formValues.time"
                            label="Uhrzeit"
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :errors="errors.collect('time')"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu"
                          v-model="formValues.time"
                          format="24hr"
                          full-width
                          @click:minute="
                            $refs.menu.save(formValues.time)
                          "
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <base-date-picker
                        v-model="formValues.to"
                        label="Datum Ende"
                        :errors="errors.collect('to')"
                      ></base-date-picker>
              </v-col>
              <v-col></v-col>
            </v-row>

            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'event.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem, fetchEventCateories } from "../shared/services";
export default {
  name: "app-event-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: "",
        time: null
      },
      permissions: [],
      loading: true,
      menu: false,
      eventCategories:[],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    this.loading = true;
    this.getData().then(() => {
      if (this.$route.params.id) {
        fetchItem(this.$route.params.id).then(res => {
          this.formValues = res.data;
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    getData() {
      return Promise.all([
        this.getEventCategories(),
      ]);
    },
    async getEventCategories() {
      this.eventCategories = (await fetchEventCateories(this.options)).data;
    },
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: 'success' });
        this.$router.push({ name: "event.index" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
